import type { PropsWithChildren } from 'react';
import React from 'react';

const ModalFooter: React.FC<PropsWithChildren> = (props): React.ReactElement => {
  return <div className="ModalFooter">{props.children}</div>;
};

export default ModalFooter;
